import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MenuItem } from '@shared/models/menu-item.model';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';

@Component({
    selector: '[app-footer-menu-item]',
    templateUrl: './footer-menu-item.component.html',
    styleUrls: ['./footer-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TranslatePipe, LocalizePipe],
})
export class FooterMenuItemComponent {
    @Input({ required: true }) item!: MenuItem;
}
